import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import {
  HomePage,
  BisnisPage,
  DetailPage,
  LembagaPage,
  LiveStreaming,
  PendidikanPage,
  Kumpulan,
  ContentDetail,
  GaleriPage,
  JenjangPage,
  PsbPage,
  SarprasPage,
  ProgramPage,
} from "./pages";

import { Suspense } from "react";
import { LanguageProvider } from "./Func/LanguageContext";
import useAnalytics from "./lib/useAnalytics";
import PageUnderDevelopment from "./pages/PageUnderDevelopment";
import KebijakanPrivasi from "./pages/KebijakanPrivasi";
import SyaratKetentuan from "./pages/SyaratKetentuan";
import HubungiKami from "./pages/HubungiKami";

function App() {
  useAnalytics();

  const Load = () => {
    return (
      <div className="h-screen w-full flex items-center justify-center text-base-semibold">
        Loading...
      </div>
    );
  };

  return (
    <LanguageProvider>
      <Suspense fallback={<Load />}>
        <Routes>
          {/* umum  */}
          <Route path="/" element={<HomePage />} />
          <Route path="/bisnis" element={<BisnisPage />} />
          <Route path="/lembaga" element={<LembagaPage />} />
          <Route path="/pendidikan" element={<PendidikanPage />} />
          <Route path="/livestreaming" element={<LiveStreaming />} />
          <Route path="/kumpulan/:params" element={<Kumpulan />} />
          <Route path="/content/:page/:id/:slug" element={<ContentDetail />} />
          <Route path="/headline/:id/:slug" element={<DetailPage />} />
          <Route path="/galeri" element={<GaleriPage />} />
          <Route path="/jenjang/:jenjangId" element={<JenjangPage />} />
          <Route path="/psb" element={<PsbPage />} />
          <Route path="/sarpras" element={<SarprasPage />} />
          <Route path="/program-unggulan" element={<ProgramPage />} />

          {/* Footer */}
          <Route path="/kebijakan-privasi" element={<KebijakanPrivasi />} />
          <Route path="/syarat-ketentuan" element={<SyaratKetentuan />} />
          <Route path="/hubungi-kami" element={<HubungiKami />} />

          {/* Page Under Development */}
          <Route path="/prasekolah" element={<PageUnderDevelopment />} />
          <Route path="/dikdas" element={<PageUnderDevelopment />} />
          <Route path="/dikti" element={<PageUnderDevelopment />} />
        </Routes>
      </Suspense>
    </LanguageProvider>
  );
}

export default App;
